import apiRequest from '../api/apiRequest';
import { StripePrice, StripeProduct } from '../types';

export async function getStripeProduct(stripeProductID: string) {
  return apiRequest<{ product: StripeProduct; prices: StripePrice[] }>(
    'user',
    `/stripe/product/${stripeProductID}`,
  );
}
